module.exports = __webpack_public_path__ + "media/images/icon/external-6fbc0b905cb2fc5c31f3d6be184f0074.svg";